import {Router} from '@angular/router';
import {Logger} from '../utils/Logger';
import {isEmpty, startCase} from 'lodash';
import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MatDialog} from '@angular/material/dialog';
import {Preferences} from '../model/preferences.model';
import {ConfigService} from '../service/config.service';
import {ApiServiceService} from '../api-service.service';
import {ChartData} from '../doughnut/doughnut.component';
import {ChartDataUtil} from '../doughnut/chart-data.util';
import {InvestmentType} from '../model/investment-type.model';
import {Keys, StorageService} from '../service/storage.service';
import {PreferencesService} from '../service/preferences.service';
import {LenderDetailsService} from '../service/lender-details.service';
import {InvestmentNavigator} from '../utils/investment-navigator';
import {LoanAgreementComponent, Result} from '../loanAgreement/loanAgreement.component';
import {CreatePortfolioComponent} from '../create-portfolio/create-portfolio.component';
import {PortfolioService} from '../service/portfolio.service';
import {UserAttributeInterface} from '../model/finzy-flex/user-attribute.model';
import {Toaster, Type} from '../toaster/Toaster';
import {ShowTurnOffSwiftPopupUtil} from '../utils/finzy-flex/show-turn-off-swift-popup.utils';

@Component({
    selector: 'app-investordashboard',
    templateUrl: './investordashboard.component.html',
    styleUrls: ['./investordashboard.component.css'],
    providers: [ApiServiceService, PreferencesService, PortfolioService]
})
export class InvestordashboardComponent implements OnInit {

    result2: any;
    result: any;
    name: string;
    photo: string;
    loanAmt: number;
    emi_amount: number;
    loan_tenure: number;
    minimumInvestmentLimit: number;
    maximumInvestmentLimit: number;
    rating: string;
    manualInvestDashboardError: boolean;
    manualInvestDashboardErrorMsg: string;
    lender10LakhLimitDeclarationCheck: boolean;
    lenderPortfolios: Array<any>;
    document: Array<any>;
    public metrics: {
        principalOutstanding: number, roi: number,
        portfolioMetrics: [{ id: string, roi: number }]
    };
    walletAmount: number;
    investmentAmt: number;
    denomination: number;
    fractionSize = '1.2-2';
    overallChartData: ChartData[];
    preferences: Preferences;
    portfolioChartData: { portfolioId: string, chartData: ChartData[] }[];
    insufficientWallet: boolean;
    isMinimumWalletBalanceExistForInitialPortfolio: boolean;
    lenderDetails: any;
    loader: {spin: boolean} = {spin: false};

    public networkCallInProgress: boolean;
    private userId: string;
    private readonly chartDataUtil: ChartDataUtil;
    private readonly storageService: StorageService;
    private readonly preferenceService: PreferencesService;
    private readonly lenderDetailsService: LenderDetailsService;
    private readonly manualInvestNavigator: InvestmentNavigator;
    private readonly portfolioService: PortfolioService;
    private readonly showTurnOffSwiftPopup: ShowTurnOffSwiftPopupUtil;
    isFINXLender: boolean = false;

    constructor(private http: HttpClient, private router: Router, private ref: ApiServiceService, public dialog: MatDialog,
                lenderDetailsService: LenderDetailsService, storageService: StorageService, manualInvestNavigator: InvestmentNavigator,
                preferencesService: PreferencesService, chartDataUtil: ChartDataUtil, portfolioService: PortfolioService, showTurnOffSwiftPopup: ShowTurnOffSwiftPopupUtil) {
        this.storageService = storageService;
        this.lenderDetailsService = lenderDetailsService;
        this.manualInvestNavigator = manualInvestNavigator;
        this.preferenceService = preferencesService;
        this.chartDataUtil = chartDataUtil;
        this.portfolioService = portfolioService;
        this.overallChartData = [];
        this.showTurnOffSwiftPopup = showTurnOffSwiftPopup;
        this.isFINXLender = this.storageService.getItem(Keys.FINX) === "true" && this.storageService.getItem(Keys.IS_LENDER_CREATED_AFTER_RESTRICTED_DATE) === "true";
    }

    closeModal() {
        this.dialog.closeAll();
        this.router.navigate(['investorwallet']);
    }

    openDialog() {
        if (!this.isPortfolioCreationEnabled()) {
            return;
        }

        this.dialog.open(CreatePortfolioComponent, {
            data: {
                principalOutstanding: this.metrics.principalOutstanding,
                numOflenderPortfolios: this.lenderPortfolios? this.lenderPortfolios.length: 0,
                walletAmount: this.walletAmount ?? 0,
            }
        });
    }

    async ngOnInit() {
        const lenderId = this.storageService.getItem(Keys.LENDER_ID);
        const userId = this.storageService.getItem(Keys.PROFILE_ID);
        this.networkCallInProgress = true;
        this.denomination = ConfigService.getDenomination();
        this.minimumInvestmentLimit = ConfigService.getMinimumInvestmentLimit();
        this.maximumInvestmentLimit = ConfigService.getMaximumInvestmentLimit();
        this.dialog.closeAll();

        await this.getAndShowLenderMetrics();

        this.name = startCase(this.storageService.getItem(Keys.NAME).toLowerCase());
        this.lenderPortfolios = await this.getLenderPortfolios(lenderId);
        this.populateInvestmentChartData(this.lenderPortfolios);

        this.lenderDetails = await this.lenderDetailsService.getLenderWalletAmountAndPhotoUrl(userId);
        this.updateWalletAmount(this.lenderDetails);
        this.updateUserPhoto(this.lenderDetails);
        this.networkCallInProgress = false;
        this.userId = this.storageService.getItem(Keys.PROFILE_ID);
        this.preferences = await this.preferenceService.getUserPreferences(this.userId);
    }

    populateInvestmentChartData(portfolios: any[]): void {
        this.overallChartData = this.chartDataUtil.convertToChartData(portfolios);
    }

    showPieChart(): boolean {
        return this.overallChartData.some(c => c.data !== 0);
    }

    onCreateManualPortfolioClicked(inv_amount) {
        if ((inv_amount >= this.minimumInvestmentLimit) && (inv_amount <= this.maximumInvestmentLimit) && (inv_amount % this.denomination === 0) && (this.walletAmount >= inv_amount) && this.lender10LakhLimitDeclarationCheck) {
            this.showLoanAgreement(InvestmentType.Manual, inv_amount);
        } else {
            if (inv_amount > this.maximumInvestmentLimit) {
                this.manualInvestDashboardError = true;
                this.manualInvestDashboardErrorMsg = ``;
            }
            if (inv_amount < this.minimumInvestmentLimit) {
                this.manualInvestDashboardError = true;
                this.manualInvestDashboardErrorMsg = `Minimum Investment amount is ${this.minimumInvestmentLimit}`;
            } else if (inv_amount % this.denomination !== 0) {
                this.manualInvestDashboardError = true;
                this.manualInvestDashboardErrorMsg = 'Investment amount should be in multiples of 1,000';
            } else if (!this.lender10LakhLimitDeclarationCheck) {
                this.manualInvestDashboardError = true;
                this.manualInvestDashboardErrorMsg = 'Please confirm that the total investments across all P2P platforms does not exceed ₹ 50 Lakh';
            }
        }
    }

    async onCreateAutoPortfolioClicked(inv_amount) {
        if(this.showTurnOffSwiftPopup.isSwiftEnabled(this.preferences)) {
            try {
                const response: UserAttributeInterface = await this.showTurnOffSwiftPopup.showFinzySwiftPopup(this.preferences, this.loader, this.userId);
                this.loader.spin = false;
                if (response.status === 0) {
                    this.preferences.investmentAttrs = response.data[0].investmentPreferences;
                    Toaster.toast('Your swift preference switched off successfully!', Type.Success);
                    this.showLoanAgreement(InvestmentType.Auto, inv_amount);
                } 
                else if(response.status === 1){
                    Toaster.toast('Failed to update preference. Please try again after sometime.', Type.Error);
                }
            } catch(error) {
                Toaster.toast('Please try again', Type.Error);
                this.loader.spin = false;
            }
        }
        else {
            this.showLoanAgreement(InvestmentType.Auto, inv_amount);
        }
    }

    showLoanAgreement(investmentType: InvestmentType, investmentAmount) {
        const dialogRef = this.dialog.open(LoanAgreementComponent);
        dialogRef.afterClosed().subscribe((result) => {
            if (result === Result.ACCEPTED) {
                this.storageService.saveObjectToSession(Keys.LENDER_10LAKH_LIMIT_CHECK, this.lender10LakhLimitDeclarationCheck);

                switch (investmentType) {
                    case InvestmentType.Auto:
                        this.createAutoInvestPortfolio(investmentAmount);
                        break;
                    case InvestmentType.Manual:
                        this.createManualInvestPortfolio(investmentAmount);
                        break;
                    default:
                        Logger.log('I don\'t know how I got here. :|');
                }
            }
        });
    }

    onLenderInvestmentLimitConfirmed() {
        if (this.lender10LakhLimitDeclarationCheck) {
            this.manualInvestDashboardError = false;
            this.manualInvestDashboardErrorMsg = '';
        }
    }

    public async getAndShowLenderMetrics(): Promise<void> {
        this.metrics = await this.lenderDetailsService.getMetricsInfo(this.storageService.getItem(Keys.LENDER_ID));
    }

    isPortfolioCreationEnabled(): boolean {
        return this.isPrincipalOutstandingAboutToBeBreached() && !this.areAutomaticInvestmentsFromWalletEnabled();
    }

    public areAutomaticInvestmentsFromWalletEnabled() {
        return this.preferences ? this.preferences.automaticInvestmentsFromWallet : false;
    }

    isFormValid(isValidInputValue: boolean): boolean {
        return (isValidInputValue && this.lender10LakhLimitDeclarationCheck && (this.investmentAmt <= this.walletAmount)
            && (this.investmentAmt >= this.minimumInvestmentLimit) && (this.investmentAmt <= this.maximumInvestmentLimit) && (this.investmentAmt % this.denomination === 0));
    }

    public getInvestmentAmountInfoMessage(): string {
        const fiftyPercentOfWalletAmount = (this.walletAmount - (this.walletAmount * 50 / 100));
        if (this.investmentAmt && this.investmentAmt.toString().length > 3 && this.investmentAmt < 50000 && this.investmentAmt < fiftyPercentOfWalletAmount) {
            return 'Creating smaller portfolios increases diversification, but it also increases the time your money ' +
                'has to wait in queue to invest in new loans. Consider creating a portfolio of ' + fiftyPercentOfWalletAmount +
                ' or more.';
        }
        return '';
    }

    private async getLenderPortfolios(lenderId: string): Promise<any[]> {
        const lenderPortfolios = await this.portfolioService.getLenderPortfoliosInfo(lenderId);
        if (isEmpty(lenderPortfolios)) {
            return [];
        }
        return lenderPortfolios;
    }

    private isPrincipalOutstandingAboutToBeBreached() {
        const maximumInvestmentLimit = ConfigService.getMaximumInvestmentLimit();
        const minimumInvestmentLimit = ConfigService.getMinimumInvestmentLimit();
        return this.metrics ? (this.metrics.principalOutstanding <= maximumInvestmentLimit - minimumInvestmentLimit) : false;
    }

    private updateUserPhoto(lenderDetails): void {
        this.photo = lenderDetails?.photoFileUrl;
    }

    private updateWalletAmount(lenderDetails): void {
        const minimumWalletBalanceForInitialPortfolio = ConfigService.getMinimumWalletBalanceForInitialPortfolio();
        const walletAmount = lenderDetails?.walletAmount;
        this.walletAmount = Math.round(walletAmount * 100) / 100;
        if (walletAmount < this.minimumInvestmentLimit) {
            this.insufficientWallet = true;
        } else {
            this.insufficientWallet = false;
            this.storageService.saveItem(Keys.WALLET_AMOUNT, walletAmount);
        }
        if (this.lenderPortfolios.length === 0 && walletAmount < minimumWalletBalanceForInitialPortfolio) {
            this.isMinimumWalletBalanceExistForInitialPortfolio = false;
        } else {
            this.isMinimumWalletBalanceExistForInitialPortfolio = true;
        }
    }

    private createManualInvestPortfolio(inv_amount) {
        this.manualInvestNavigator.navigateToManualInvestListingPage(inv_amount);
    }

    private createAutoInvestPortfolio(inv_amount) {
        this.manualInvestNavigator.navigateToAutoInvest(inv_amount);
    }
}
